// ------------------------------
// Global Swiper Variables
// ------------------------------
let recommendedSwiper = null;
let collectionSwiper = null;
let activeSwiper = null;

// ------------------------------
// Existing Recommended Products Logic (AJAX load)
// ------------------------------
const recommeneded_section = document.querySelector('.product-recommendations');
const options = { rootMargin: '400px' };

const observer = new IntersectionObserver(entries => {
  if (entries[0].isIntersecting === true) {
    observer.unobserve(recommeneded_section);
    const productRecommendationsSection = document.querySelector('.product-recommendations');
    const url = productRecommendationsSection.dataset.url;
    
    // Always fetch recommendations from the URL
    fetch(url)
      .then(response => {
        if (!response.ok) {
          console.error("response was not ok");
          return null;
        }
        return response.text();
      })
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          // Initialize recommended swiper WITHOUT navigation binding
          recommendedSwiper = new window.swiper('.recommendations-slider', {
            slidesPerView: 1.15,
            spaceBetween: 10,
            breakpoints: {
              768: { 
                slidesPerView: 3,
                spaceBetween: 20,
              },
              992: { 
                slidesPerView: 4,
                spaceBetween: 20,
              }
            },
            lazy: {
              enabled: true,
              checkInView: false,
              loadOnTransitionStart: true,
              loadPrevNext: true,
              loadPrevNextAmount: 1
            },
            on: {
              init: function() {
                updateNavigationButtons(this);
              },
              slideChange: function() {
                updateNavigationButtons(this);
              }
            }
          });
          // If the recommended tab is active, set it as activeSwiper
          if (document.querySelector('.recommended-tabs .tab.active').getAttribute('data-tab') === 'recommended') {
            activeSwiper = recommendedSwiper;
          }
        }
      })
      .catch(error => {
        console.error(error);
      });
  }
}, options);

observer.observe(recommeneded_section);

// ------------------------------
// Shared Navigation Controls
// ------------------------------
const nextButton = document.querySelector('.recommendations-slider-controls .swiper-button-next');
const prevButton = document.querySelector('.recommendations-slider-controls .swiper-button-prev');

if (nextButton) {
  nextButton.addEventListener('click', function() {
    if (activeSwiper) { activeSwiper.slideNext(); }
  });
}
if (prevButton) {
  prevButton.addEventListener('click', function() {
    if (activeSwiper) { activeSwiper.slidePrev(); }
  });
}

// ------------------------------
// Update Navigation Buttons Function
// ------------------------------
function updateNavigationButtons(swiper) {
  if (!swiper) return;
  if (swiper.isBeginning) {
    prevButton.classList.add('swiper-button-disabled');
  } else {
    prevButton.classList.remove('swiper-button-disabled');
  }
  if (swiper.isEnd) {
    nextButton.classList.add('swiper-button-disabled');
  } else {
    nextButton.classList.remove('swiper-button-disabled');
  }
}

// ------------------------------
// Tab Switching & Collection Swiper Initialization
// ------------------------------
document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('.recommended-tabs .tab');
  const tabContents = document.querySelectorAll('.tab-content');

  // Switch tabs using data attributes
  function switchTab(tabName) {
    tabContents.forEach(content => {
      content.style.display = 'none';
    });
    tabs.forEach(tab => {
      tab.classList.remove('active');
    });
    const activeContent = document.querySelector(`.tab-content[data-tab-id="${tabName}"]`);
    if (activeContent) { activeContent.style.display = 'block'; }
    const activeTab = document.querySelector(`.recommended-tabs .tab[data-tab="${tabName}"]`);
    if (activeTab) { activeTab.classList.add('active'); }
  }

  // Initialize collection swiper (rendered by Liquid)
  function initCollectionSwiper() {
    if (!collectionSwiper) {
      collectionSwiper = new window.swiper('.collection-slider', {
        slidesPerView: 1.15,
        spaceBetween: 10,
        breakpoints: {
          768: { 
            slidesPerView: 3,
            spaceBetween: 20,
          },
          992: { 
            slidesPerView: 4,
            spaceBetween: 20,
          }
        },
        lazy: {
          enabled: true,
          checkInView: false,
          loadOnTransitionStart: true,
          loadPrevNext: true,
          loadPrevNextAmount: 1
        },
        on: {
          init: function() {
            updateNavigationButtons(this);
          },
          slideChange: function() {
            updateNavigationButtons(this);
          }
        }
      });
    }
    activeSwiper = collectionSwiper;
  }

  // Attach click events to tabs
  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      const tabName = this.getAttribute('data-tab');
      switchTab(tabName);
      if (tabName === 'recommended') {
        activeSwiper = recommendedSwiper;
        updateNavigationButtons(activeSwiper);
      } else if (tabName === 'collection') {
        initCollectionSwiper();
        updateNavigationButtons(activeSwiper);
      }
    });
  });

  // On initial load, ensure the active tab's swiper is set
  const initialTab = document.querySelector('.recommended-tabs .tab.active').getAttribute('data-tab');
  if (initialTab === 'collection') {
    initCollectionSwiper();
  } else {
    activeSwiper = recommendedSwiper;
  }
});
